import { useEffect, useState } from 'react';
import { SharedValue, useAnimatedStyle, useSharedValue, withTiming } from 'react-native-reanimated';
import { brand, neutrals, progressColor } from 'src/theme/colors';

export const useDiscountMilestoneLogic = (
  index: number,
  steps: number,
  progressSV: SharedValue<number>,
  anyMilestoneShowingCheckSV: SharedValue<boolean>,
  lastReachedMilestone?: number | null,
) => {
  const left = (index / (steps - 1)) * 100;
  const showCheckSV = useSharedValue(0);

  useEffect(() => {
    if (lastReachedMilestone === index) {
      anyMilestoneShowingCheckSV.value = true;

      showCheckSV.value = withTiming(1, { duration: 250 });

      setTimeout(() => {
        showCheckSV.value = withTiming(0, { duration: 350 });
        anyMilestoneShowingCheckSV.value = false;
      }, 1500);
    }
  }, [lastReachedMilestone, index]);

  const milestoneAnimatedStyle = useAnimatedStyle(() => {
    const isActive = progressSV.value >= left;
    const backgroundColor = showCheckSV.value === 1 ? true : false;
    return {
      backgroundColor: backgroundColor ? progressColor.checkIcon : isActive ? brand.main.orange : progressColor.bar,
      transform: [
        {
          scale: withTiming(showCheckSV.value === 1 ? 1.25 : 1, { duration: 250 }),
        },
      ],
    };
  });

  const textAnimatedStyle = useAnimatedStyle(() => {
    const opacity = showCheckSV.value === 1 ? 0 : 1;
    const isActive = progressSV.value >= left;
    return {
      opacity: withTiming(opacity, { duration: 250 }),
      color: isActive ? neutrals.white : brand.main.orange,
    };
  });

  const checkAnimatedStyle = useAnimatedStyle(() => {
    const opacity = showCheckSV.value;
    return {
      opacity: withTiming(opacity, { duration: 200 }),
      transform: [
        {
          scale: withTiming(opacity ? 1 : 0.5, { duration: 200 }),
        },
      ],
    };
  });

  const [confettiLayout, setConfettiLayout] = useState<{ width: number; height: number } | null>(null);
  const showConfetti = lastReachedMilestone === index;

  const onLayout = e => {
    const { width, height } = e.nativeEvent.layout;
    setConfettiLayout({ width, height });
  };

  return {
    left,
    milestoneAnimatedStyle,
    textAnimatedStyle,
    checkAnimatedStyle,
    confettiLayout,
    showConfetti,
    onLayout,
  };
};
